<script>
import appConfig from "@/app.config";
import axios from "axios";
import loadingVue from "@/components/loading.vue";

export default {
  components: {
    loadingVue,
  },
  page: {
    title: "Student",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          active: true,
        },
      ],
      params: this.$route.params,
      isLoading: true,
      setRespv: null,
      setPaketSoal: [],
      selectedTryout: null,
      showDetailModal: false,
      setListPaketSoal: null,
      setDataSearch: [],
      selectedFilter: null,
      selected: null,
      options: [
        { value: null, text: "Pilih Jenis Paket", disabled: true },
        { value: "", text: "Semua" },
        { value: "1", text: "Ujian" },
        { value: "0", text: "Latihan/TryOut" },
      ],
      errorMessage: false,
    };
  },
  mounted() {
    this.getPaketSoal();
  },
  methods: {
    formattedText(teks) {
      let newTeks = teks.replace("Test", "");
      return teks ? newTeks : "";
    },
    /**
     * Get list of paket soal by subid and question category
     *
     * @return {Promise<void>}
     */
    async getPaketSoal() {
      const currentTryout = localStorage.getItem("currentTryout");
      let url = `/api/json/get-distribusi-soal-subid?question_category=${this.params.questioncategory}&is_ujian=1&programme_ids=${this.params.subid}`;

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + url)
        .then((response) => {
          this.setPaketSoal = response.data;
          this.isLoading = false;
          if (currentTryout) {
            const storedTryout = JSON.parse(currentTryout);
            const findTryout = response.data.find(
              (item) =>
                item.package_id === storedTryout || item.tryout === storedTryout
            );
            if (findTryout) {
              this.openTryoutDetail(findTryout);
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.errorMessage = true;
            this.isLoading = false;
          }
        });
    },
    openTryoutDetail(tryout) {
      // Fetch additional details for the tryout if needed
      this.selectedTryout = tryout;
      localStorage.setItem(
        "currentTryout",
        JSON.stringify(tryout.package_id || tryout.tryout)
      );
      this.showDetailModal = true;
      localStorage.removeItem("previousUrl");
    },

    closeTryoutDetail() {
      this.showDetailModal = false;
      this.selectedTryout = null;
      localStorage.removeItem("currentTryout");
    },
    /**
     * Starts the automatic exam process by checking the current URL and the selected tryout.
     * If there are no questions in the selected tryout or if it is not selected, an alert is shown.
     * Finds the first unfinished question in the tryout and navigates to its start page.
     * If all questions are finished, an alert is displayed.
     */

    startAutoExam() {
      const currentUrl = window.location.pathname;
      localStorage.setItem("previousUrl", currentUrl);

      if (!this.selectedTryout || !this.selectedTryout.question.length) {
        alert("Tidak ada soal untuk dikerjakan.");
        return;
      }

      // Find the first unfinished question
      const nextQuestion = this.selectedTryout.question.find(
        (q) => !q.is_finished
      );

      if (nextQuestion) {
        // Perform navigation or logic to start this question
        this.$router.push(`/student/ujian/${nextQuestion.soal.id}/start`);

        // Here you can add your navigation or routing logic
      } else {
        alert("Semua soal telah selesai dikerjakan.");
      }
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <div>
    <!-- Error Message Section (Existing) -->
    <div v-if="errorMessage" class="alert alert-danger" role="alert">
      <h1 align="center">
        Anda tidak mempunyai akses pada halaman ini, Silahkan Klik dibawah ini.
      </h1>
    </div>

    <div v-if="errorMessage" class="logout w-25 mx-auto">
      <a class="dropdown-item" href="/logout">
        <i
          class="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"
        ></i>
        <span class="align-middle">{{
          $t("navbar.dropdown.marcus.list.logout")
        }}</span>
      </a>
    </div>

    <!-- Tryout List Section (Existing) -->
    <div v-if="isLoading !== true">
      <div class="mt-3 mb-3">
        <b-row v-if="setPaketSoal && setPaketSoal.length > 0">
          <template v-for="dataBody in setPaketSoal">
            <b-col
              sm="3"
              md="3"
              lg="3"
              :key="dataBody.package_id || dataBody.tryout"
            >
              <div
                class="card"
                :class="{
                  'cursor-pointer': !dataBody.disabled,
                  'cursor-disabled': dataBody.disabled,
                }"
                @click="!dataBody.disabled && openTryoutDetail(dataBody)"
              >
                <div
                  class="card-body border-3 rounded-3 text-uppercase d-flex justify-content-between align-items-center"
                >
                  <span
                    :class="{
                      'fs-5 fw-semibold': true,
                      'text-secondary': dataBody.disabled,
                      'text-dark': !dataBody.disabled,
                    }"
                  >
                    {{ dataBody.tryout || "-" }}
                  </span>

                  <span
                    v-if="dataBody.complete"
                    class="fs-5 fw-bold text-success"
                  >
                    <b-icon icon="check-circle-fill"></b-icon>
                  </span>

                  <span
                    v-else
                    :class="{
                      'fs-5 fw-semibold': true,
                      'text-secondary': dataBody.disabled,
                      'text-dark': !dataBody.disabled,
                    }"
                  >
                    <b-icon icon="chevron-right"></b-icon>
                  </span>
                </div>
              </div>
            </b-col>
          </template>
        </b-row>
      </div>

      <!-- No Tryout Available Message (Existing) -->
      <div
        v-if="setPaketSoal.length == 0"
        class="d-flex justify-content-center align-items-center"
        style="height: 70vh;"
      >
        <p class="fs-3">
          Belum ada tryout atau program yang kamu pilih tidak sesuai.
        </p>
      </div>
    </div>

    <!-- Loading Spinner (Existing) -->
    <div
      style="height: 74vh;"
      class="d-flex justify-content-center align-items-center"
      v-else
    >
      <loading-vue></loading-vue>
    </div>

    <!-- Tryout Detail Modal -->
    <b-modal
      v-model="showDetailModal"
      :title="selectedTryout ? selectedTryout.tryout.toUpperCase() : ''"
      @hide="closeTryoutDetail"
      size="xl"
      centered
      hide-footer
    >
      <div v-if="selectedTryout">
        <div class="row mb-3">
          <div class="col-md-6 px-4">
            <div class="steps-container">
              <div
                v-for="(question, index) in selectedTryout.question"
                :key="question.id"
                class="step"
              >
                <div v-if="question.is_finished" class="step-check">
                  <b-icon icon="check-circle-fill" variant="success"></b-icon>
                </div>

                <div v-else class="step-number">
                  {{ index + 1 }}
                </div>

                <div class="step-content">
                  <div class="d-flex justify-content-between">
                    <div class="step-title text-uppercase fw-bold">
                      {{ formattedText(question.soal.paket) || "Tanpa Judul" }}
                    </div>
                    <div class="d-flex gap-2">
                      <div class="step-description fw-bold">
                        ID {{ question.soal.id || 0 }} |
                      </div>
                      <div class="step-description fw-bold">
                        {{ question.length_soal || 0 }} Soal |
                      </div>
                      <div class="step-description fw-bold">
                        {{ question.soal.waktu || 0 }} M
                      </div>
                    </div>
                  </div>
                  <div class="step-description">
                    {{ question.soal.deskripsi || "Tidak ada deskripsi" }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="container">
              <p class="fw-bold fs-5 text-danger">
                Silahkan kerjakan soal yang telah di siapkan. Harap dipatuhi
                peraturan berikut!
              </p>
              <div class="step-custom">
                <p class="step-description-info">
                  Jangan mereload/refresh browser, jika web browser di refresh
                  maka ujian akan dinyatakan selesai.
                </p>
              </div>
              <div class="step-custom">
                <p class="step-description-info">
                  Jangan menekan tombol selesai saat mengerjakan soal, kecuali
                  saat anda telah selesai mengerjakan seluruh soal
                </p>
              </div>
              <div class="step-custom">
                <p class="step-description-info">
                  Perhatikan sisa waktu ujian, sistem akan mengumpulkan jawaban
                  saat waktu sudah selesai
                </p>
              </div>
              <div class="step-custom">
                <p class="step-description-info">
                  Waktu ujian akan dimulai saat tombol "<b>Mulai</b>" di klik
                </p>
              </div>
              <div class="step-custom">
                <p class="step-description-info">
                  Jangan membuka tab baru pada saat ujian, jika membuka tab baru
                  maka ujian akan dinyatakan selesai.
                </p>
              </div>
            </div>

            <div
              v-if="selectedTryout.complete"
              class="d-flex justify-content-end align-items-end mt-4 container"
            >
              <b-link
                class="btn btn-outline-purple purple fw-bold w-100"
                href="/scores"
              >
                Lihat Nilai
              </b-link>
            </div>

            <div
              v-else
              class="d-flex justify-content-end align-items-end mt-4 container"
            >
              <b-button
                class="btn btn-purple fw-bold w-100"
                @click="startAutoExam()"
              >
                Mulai
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.step-custom {
  border-left: 3px solid;
}
.step-description-info {
  margin-left: 1rem;
  font-size: 1rem;
}

.steps-container {
  position: relative;
  padding-left: 30px;
}

.step {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.step-number {
  position: absolute;
  left: -30px;
  width: 30px;
  height: 30px;
  background-color: #6c757d;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 10px;
}

.step-check {
  position: absolute;
  left: -30px;
  width: 30px;
  height: 30px;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 10px;
  font-size: 25px;
}

.step-content {
  flex-grow: 1;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-right: 15px;
}

.step-title {
  font-size: 1rem;
  margin-bottom: 5px;
}

.step-description {
  color: #6c757d;
  font-size: 0.854rem;
}

.step-status {
  display: flex;
  align-items: center;
}
.bg-custom {
  background-color: var(--bs-indigo);
}
.border-custom {
  border-color: #adb5bd !important;
}
.custom-select {
  padding: 0.75rem !important;
  font-size: 1rem !important;
}
.cursor-pointer {
  cursor: pointer;
  transition: transform 0.2s;
}
.cursor-disabled {
  cursor: not-allowed;
  transition: transform 0.2s;
}
.cursor-pointer:hover {
  transform: scale(1.02);
}
.card {
  border-radius: 10px !important;
}
</style>
